module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"no_item_message":"등록된 동영상이 없습니다."}}')
  delete Component.options._Ctor
}
